import { createSelector } from "reselect";
import getPlatform from "./getPlatform";

const getOsVersionFloat = createSelector(getPlatform, (platform) => {
  if (!platform.os.version) {
    return null;
  }

  const [major, minor] = platform.os.version.split(".");
  return parseFloat(`${major}.${minor}`);
});

export default getOsVersionFloat;
